export const API_BASE_URL = 'https://pebblehrm.annaiarulhospital.com/aah-api/api';
export const APP_BASE_URL = 'https://pebblehrm.annaiarulhospital.com';



